"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var infoNormalizer = function (response) {
    var data = response.data;
    if (!data) {
        return __assign(__assign({}, response), { data: null });
    }
    return __assign(__assign({}, response), { data: {
            country: data.country,
            latitude: data.lat,
            longitude: data.long,
            hostname: data.hostname,
        } });
};
exports.default = infoNormalizer;
